import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ClassTypeComponent } from './class-type.component';
import { ClassTypeDetailComponent } from './class-type-detail.component';
import { ClassTypePopupComponent } from './class-type-dialog.component';
import { ClassTypeDeletePopupComponent } from './class-type-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ClassTypeResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const classTypeRoute: Routes = [
    {
        path: 'class-type',
        component: ClassTypeComponent,
        resolve: {
            'pagingParams': ClassTypeResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.classType.home.title'
        }
    }, {
        path: 'class-type/:id',
        component: ClassTypeDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.classType.home.title'
        }
    }
];

export const classTypePopupRoute: Routes = [
    {
        path: 'class-type-new',
        component: ClassTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.classType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'class-type/:id/edit',
        component: ClassTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.classType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'class-type/:id/delete',
        component: ClassTypeDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.classType.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.route.ts